import React, { useEffect } from 'react'
import { Link, } from 'react-router-dom';
import Swal from 'sweetalert2';

import useAuth from '../../controllers/users/useAuth';
import { checkIfUserIsMaster, responseGet, globalSettings, navSetting, styles, sendMessageCloseCurrentWindowAsync, languageObjGet, isUndNullEmp, } from '../../helpers/settings';
import { GlobalFormats } from '../../classes/main/globalFormats';

const currentMethod = 'Menu';

const { app, colors, html, icons, images, labels, messages, react, roles, } = globalSettings;
const { sweetAlert2, } = react;
const { backend, processes, viewNames, } = app;

export default function Menu({
    viewName = '',
    process = '',
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    const auth = useAuth();
    //#region old code
    //const viewName = !isUndefined(viewName) ? viewName : '';
    //const process = !isUndefined(process) ? process : '';
    //const userRole = checkIfUserIsMaster(auth.user !== null ? auth?.user?.email : '').result;
    //#endregion old code
    const userRole = checkIfUserIsMaster({ email: auth?.user?.email || '', languageId: languageObj?.id, subMethod: currentMethod, }).result;
    let swalProperty = {};
    //#endregion variables

    //#region methods
    const signOutShowModelAsync = async ({ e = {}, }) => {
        const currentMethod = 'signOutShowModelAsync';
        let response = responseGet();
        try {
            e?.preventDefault();
            swalProperty = {
                icon: sweetAlert2?.icons?.warning,
                title: labels?.warning?.[languageObj?.id],
                html: messages?.areYouSureToLogOut?.[languageObj?.id],
                timer: null,
                confirmButtonColor: colors?.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: true,
                cancelButtonColor: colors?.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
            };

            //#region old code
            // Swal.fire(swalProperties).then((result) => {
            //     if (result.isConfirmed) {
            //         sendMessage(2, messages?.processing?.[languageObj?.id], globalSettings?.timers?.twentySeconds, false, true, null, '');
            //         response = auth?.logout();
            //         if (!response?.isSuccess || response?.isWarning) {
            //             sendMessage(response.msgType, response.msgText, 0, true, false, null, '');
            //             return response;
            //         }
            //         window.location.href = '/';
            //     }
            // });
            //#endregion old code

            const { isConfirmed, } = await Swal.fire(swalProperty);
            if (isConfirmed) {
                response = auth?.logout({
                    subMethod: currentMethod,
                });
                if (!response?.isSuccess || response?.isWarning) {
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: 1,
                        msgText: messages?.youDoNotHaveSufficientPrivilegesToRunThisProcess?.[languageObj?.id],
                        closeWindow: false,
                        urlGoTo: backend?.urlHome,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return response;
                }
                window.location.href = '/';
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: response?.msgText,
                closeWindow: false,
                urlGoTo: backend?.urlHome,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    useEffect(() => {
    }, [auth?.user?.uid]); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <aside className='main-sidebar sidebar-dark-primary elevation-4'>
            {/* Brand Logo */}
            {/* <a href='/' className='brand-link'>
                <img src={images?.appLogo} alt='appLogo' className='brand-image img-circle elevation-3' style={styles?.appLogoHeader} />
                <span className='brand-text font-weight-light'>{app?.name }</span>
            </a> */}
            <a href='/' className='brand-link'>
                <img src={images?.appLogo}
                    alt='appLogo'
                    className='brand-image img-circle elevation-2'
                    style={styles?.appLogoHeader} />
                <span className='brand-text font-weight-light'>{app?.name}</span>
            </a>

            {/* Sidebar */}
            <div className='sidebar'>
                {/* Sidebar user panel (optional) */}
                {auth?.isLoged() ?
                    <div className='user-panel mt-3 pb-3 mb-3 d-flex'>
                        {/* <div className='image'>
                            <a href={backend?.urlProfile}>
                                <img src={!isUndNullEmp({ data: auth?.user?.photoURL, subMethod: currentMethod, })?.result ? auth.user.photoURL : images?.noImageLogo}
                                    className='img-circle elevation-2'
                                    alt='UserImage'
                                    style={styles?.leftMenuUserPicture} />
                            </a>
                        </div> */}
                        <div className='image'>
                            <a href={backend?.urlProfile}>
                                <img id={html?.controls?.main?.menu?.profile?.img?.id}
                                    src={!isUndNullEmp({ data: auth?.user?.photoURL, subMethod: currentMethod, })?.result ? auth.user.photoURL : images?.noImageLogo}
                                    className='img-circle elevation-2'
                                    alt='UserImage'
                                    style={styles?.leftMenuUserPicture} />
                            </a>
                        </div>
                        <div className='info'>
                            <a href={backend?.urlProfile}
                                className='d-block'>{!isUndNullEmp({ data: auth?.user?.displayName, subMethod: currentMethod, })?.result ? auth?.user?.displayName : labels?.undefined?.[languageObj?.id]}</a>
                        </div>
                    </div> :
                    <div></div>}

                {/* SidebarSearch Form */}
                <div className='form-inline'>
                    <div className='input-group' data-widget='sidebar-search'>
                        <input className='form-control form-control-sidebar' type='search' placeholder={labels?.search?.[languageObj?.id]} aria-label='Search' />
                        <div className='input-group-append'>
                            <button className='btn btn-sidebar'>
                                <i className='fas fa-search fa-fw' />
                            </button>
                        </div>
                    </div>
                </div>

                {/* Sidebar Menu */}
                <nav className='mt-2'>
                    {/* <ul className='nav nav-pills nav-sidebar flex-column' data-widget='treeview' role='menu' data-accordion='false'> */}
                    {/* <ul className='nav nav-pills nav-sidebar flex-column nav-compact nav-child-indent' data-widget='treeview' role='menu' data-accordion='false'></ul> */}
                    <ul className='nav nav-pills nav-sidebar flex-column nav-compact nav-child-indent' data-widget='treeview' role='menu' data-accordion='false'>

                        {/* Add icons to the links using the .nav-icon class with font-awesome or any other icon font library */}

                        {/* Home */}
                        <li className={viewName === viewNames?.home && !isUndNullEmp({ data: process, subMethod: currentMethod })?.result ? navSetting?.navItemMenuOpen : navSetting?.navItem}>

                            <a href='#nothing' className={viewName === viewNames?.home && !isUndNullEmp({ data: process, subMethod: currentMethod })?.result ? navSetting?.navLinkActive : navSetting?.navLink}>
                                <i className='nav-icon fas fa-home' />
                                <p>{labels?.home?.[languageObj?.id]}<i className={icons?.angleLeftRight} />
                                </p>
                            </a>
                            <ul className='nav nav-treeview'>
                                <li className='nav-item'>
                                    <a href='/' className={process === processes?.home ? navSetting?.navLinkActive : navSetting?.navLink}>
                                        {/* <i className='far fas fa-home nav-icon' /> */}
                                        <i className={icons?.circleNavIcon} />
                                        <p>{labels?.home?.[languageObj?.id]}</p>
                                    </a>
                                </li>
                                <li className='nav-item'>
                                    <a href={backend?.urlAbout} className={process === processes?.about ? navSetting?.navLinkActive : navSetting?.navLink}>
                                        {/* <i className='fas fa-info-circle nav-icon' /> */}
                                        <i className={icons?.circleNavIcon} />
                                        <p>{labels?.about?.[languageObj?.id]}</p>
                                    </a>
                                </li>
                                <li className='nav-item'>
                                    <a href={backend?.urlContact} className={process === process?.contact ? navSetting?.navLinkActive : navSetting?.navLink}>
                                        {/* <i className='fas fa-address-card nav-icon' /> */}
                                        <i className={icons?.circleNavIcon} />
                                        <p>{labels?.contact?.[languageObj?.id]}</p>
                                    </a>
                                </li>
                                <li className='nav-item'>
                                    <a href={backend?.urlPrivacy} className={process === process?.privacy ? navSetting?.navLinkActive : navSetting?.navLink}>
                                        {/* <i className='fas fa-shield-alt nav-icon' /> */}
                                        <i className={icons?.circleNavIcon} />
                                        <p>{labels?.privacy?.[languageObj?.id]}</p>
                                    </a>
                                </li>
                            </ul>

                        </li>

                        {/* Process */}
                        {!isUndNullEmp({ data: auth, subMethod: currentMethod, })?.result && auth?.isLoged() &&
                            !isUndNullEmp({ data: userRole, subMethod: currentMethod, })?.result ?
                            <li className={viewName === viewNames?.process && !isUndNullEmp({ data: process, subMethod: currentMethod, })?.result ? navSetting?.navItemMenuOpen : navSetting?.navItem}>
                                <a href='#nothing' className={viewName === viewNames?.process && !isUndNullEmp({ data: process, subMethod: currentMethod, })?.result ? navSetting?.navLinkActive : navSetting?.navLink}>
                                    <i className='nav-icon fas fa-list-ul' />
                                    <p>{labels?.process?.[languageObj?.id]}<i className={icons?.angleLeftRight} /></p>
                                </a>
                                <ul className='nav nav-treeview'>
                                    <li className='nav-item'>
                                        <a href={backend?.urlBuildings} className={process === processes?.buildings ? navSetting?.navLinkActive : navSetting?.navLink}>
                                            <i className={icons?.circleNavIcon} />
                                            <p>{labels?.buildings?.[languageObj?.id]}</p>
                                        </a>
                                    </li>
                                    <li className='nav-item'>
                                        <a href={backend?.urlApartments} className={process === processes?.apartments ? navSetting?.navLinkActive : navSetting?.navLink}>
                                            <i className={icons?.circleNavIcon} />
                                            <p>{labels?.apartments?.[languageObj?.id]}</p>
                                        </a>
                                    </li>
                                    <li className='nav-item'>
                                        <a href={backend?.urlBuildingDocuments} className={process === processes?.buildingDocuments ? navSetting?.navLinkActive : navSetting?.navLink}>
                                            <i className={icons?.circleNavIcon} />
                                            <p>{labels?.documents?.[languageObj?.id]}</p>
                                        </a>
                                    </li>
                                </ul>
                            </li>
                            : <div></div>
                        }

                        {/* Condominium board */}
                        {!isUndNullEmp({ data: auth, subMethod: currentMethod, })?.result && auth?.isLoged() &&
                            !isUndNullEmp({ data: userRole, subMethod: currentMethod, })?.result ?
                            <li className={viewName === viewNames?.condominiumBoard && !isUndNullEmp({ data: process, subMethod: currentMethod })?.result ? navSetting?.navItemMenuOpen : navSetting?.navItem}>
                                <a href='#nothing' className={viewName === viewNames?.condominiumBoard && !isUndNullEmp({ data: process, subMethod: currentMethod })?.result ? navSetting?.navLinkActive : navSetting?.navLink}>
                                    <i className='nav-icon fas fa-users' />
                                    <p>{labels?.condominiumBoard?.[languageObj?.id]}<i className={icons?.angleLeftRight} /></p>
                                </a>
                                <ul className='nav nav-treeview'>
                                    <li className='nav-item'>
                                        <a href={backend?.urlCondominiumBoardRoles} className={process === processes?.condominiumBoardRoles ? navSetting?.navLinkActive : navSetting?.navLink}>
                                            <i className={icons?.circleNavIcon} />
                                            <p>{labels?.roles?.[languageObj?.id]}</p>
                                        </a>
                                    </li>
                                    <li className='nav-item'>
                                        <a href={backend?.urlCondominiumBoardElections} className={process === processes?.condominiumBoardElections ? navSetting?.navLinkActive : navSetting?.navLink}>
                                            <i className={icons?.circleNavIcon} />
                                            <p>{labels?.elections?.[languageObj?.id]}</p>
                                        </a>
                                    </li>

                                    <li className='nav-item'>
                                        <a href={backend?.urlInformativeBillboards} className={process === processes?.informativeBillboard ? navSetting?.navLinkActive : navSetting?.navLink}>
                                            <i className={icons?.circleNavIcon} />
                                            <p>{labels?.informativeBillboard?.[languageObj?.id]}</p>
                                        </a>
                                    </li>

                                    <li className='nav-item'>
                                        <a href={backend?.urlReserveCommonAreas} className={process === processes?.reserveCommonAreas ? navSetting?.navLinkActive : navSetting?.navLink}>
                                            <i className={icons?.circleNavIcon} />
                                            <p>{labels?.reserveCommonArea?.[languageObj?.id]}</p>
                                        </a>
                                    </li>
                                </ul>
                                <ul className='nav nav-treeview'>

                                </ul>
                            </li>
                            : <div></div>
                        }

                        {/* Expenses */}
                        {!isUndNullEmp({ data: auth, subMethod: currentMethod, })?.result && auth?.isLoged() &&
                            !isUndNullEmp({ data: userRole, subMethod: currentMethod, })?.result ?
                            <li className={viewName === viewNames?.expenses && !isUndNullEmp({ data: process, subMethod: currentMethod })?.result ? navSetting?.navItemMenuOpen : navSetting?.navItem}>
                                <a href='#nothing' className={viewName === viewNames?.expenses && !isUndNullEmp({ data: process, subMethod: currentMethod })?.result ? navSetting?.navLinkActive : navSetting?.navLink}>
                                    <i className='nav-icon fas fa-hand-holding-usd' />
                                    <p>{labels?.expenses?.[languageObj?.id]}<i className={icons?.angleLeftRight} /></p>
                                </a>
                                <ul className='nav nav-treeview'>
                                    <li className='nav-item'>
                                        <a href={backend?.urlExpenseConcepts} className={process === processes?.concepts ? navSetting?.navLinkActive : navSetting?.navLink}>
                                            <i className={icons?.circleNavIcon} />
                                            <p>{labels?.concepts?.[languageObj?.id]}</p>
                                        </a>
                                    </li>
                                    <li className='nav-item'>
                                        <a href={backend?.urlExpenseTemplates} className={process === processes?.templates ? navSetting?.navLinkActive : navSetting?.navLink}>
                                            <i className={icons?.circleNavIcon} />
                                            <p>{labels?.templates?.[languageObj?.id]}</p>
                                        </a>
                                    </li>
                                    <li className='nav-item'>
                                        <a href={backend?.urlSuppliers} className={process === processes?.suppliers ? navSetting?.navLinkActive : navSetting?.navLink}>
                                            <i className={icons?.circleNavIcon} />
                                            <p>{labels?.suppliers?.[languageObj?.id]}</p>
                                        </a>
                                    </li>
                                    <li className='nav-item'>
                                        <a href={backend?.urlPurchases} className={process === processes?.purchases ? navSetting?.navLinkActive : navSetting?.navLink}>
                                            <i className={icons?.circleNavIcon} />
                                            <p>{labels?.purchases?.[languageObj?.id]}</p>
                                        </a>
                                    </li>
                                </ul>
                            </li>
                            : <div></div>
                        }

                        {/* Receipts */}
                        {!isUndNullEmp({ data: auth, subMethod: currentMethod, })?.result && auth?.isLoged() &&
                            !isUndNullEmp({ data: userRole, subMethod: currentMethod, })?.result ?
                            <li className={viewName === viewNames?.receipts && !isUndNullEmp({ data: process, subMethod: currentMethod })?.result ? navSetting?.navItemMenuOpen : navSetting?.navItem}>
                                <a href='#nothing' className={viewName === viewNames?.receipts && !isUndNullEmp({ data: process, subMethod: currentMethod })?.result ? navSetting?.navLinkActive : navSetting?.navLink}>
                                    <i className='nav-icon fas fa-file-invoice' />
                                    <p>{labels?.receipts?.[languageObj?.id]}<i className={icons?.angleLeftRight} /></p>
                                </a>
                                <ul className='nav nav-treeview'>
                                    <li className='nav-item'>
                                        <a href={backend?.urlReceiptGenerate} className={process === processes?.generate ? navSetting?.navLinkActive : navSetting?.navLink}>
                                            <i className={icons?.circleNavIcon} />
                                            <p>{labels?.generate?.[languageObj?.id]}</p>
                                        </a>
                                    </li>
                                    <li className='nav-item'>
                                        <a href={backend?.urlApartmentReceipts} className={process === processes?.generated ? navSetting?.navLinkActive : navSetting?.navLink}>
                                            <i className={icons?.circleNavIcon} />
                                            <p>{labels?.generated?.[languageObj?.id]}</p>
                                        </a>
                                    </li>
                                </ul>
                            </li>
                            : <div></div>
                        }

                        {/* Collection */}
                        {!isUndNullEmp({ data: auth, subMethod: currentMethod, })?.result && auth?.isLoged() &&
                            !isUndNullEmp({ data: userRole, subMethod: currentMethod, })?.result ?
                            <li className={viewName === viewNames?.collection && !isUndNullEmp({ data: process, subMethod: currentMethod })?.result ? navSetting?.navItemMenuOpen : navSetting?.navItem}>
                                <a href='#nothing' className={viewName === viewNames?.collection && !isUndNullEmp({ data: process, subMethod: currentMethod })?.result ? navSetting?.navLinkActive : navSetting?.navLink}>
                                    <i className='nav-icon fas fa-cash-register' />
                                    <p>{labels?.collection?.[languageObj?.id]}<i className={icons?.angleLeftRight} /></p>
                                </a>
                                <ul className='nav nav-treeview'>
                                    <li className='nav-item'>
                                        <a href={backend?.urlCollectionCashes} className={process === processes?.collectionCashes ? navSetting?.navLinkActive : navSetting?.navLink}>
                                            <i className={icons?.circleNavIcon} />
                                            <p>{labels?.cashRegisters?.[languageObj?.id]}</p>
                                        </a>
                                    </li>
                                    <li className='nav-item'>
                                        <a href={backend?.urlCollectionBankAccounts} className={process === processes?.collectionBankAccounts ? navSetting?.navLinkActive : navSetting?.navLink}>
                                            <i className={icons?.circleNavIcon} />
                                            <p>{labels?.bankAccounts?.[languageObj?.id]}</p>
                                        </a>
                                    </li>
                                    <li className='nav-item'>
                                        <a href={backend?.urlReconcilePayments} className={process === processes?.reconcilePayments ? navSetting?.navLinkActive : navSetting?.navLink}>
                                            <i className={icons?.circleNavIcon} />
                                            <p>{labels?.reconcilePayments?.[languageObj?.id]}</p>
                                        </a>
                                    </li>
                                </ul>
                            </li>
                            : <div></div>
                        }

                        {/* Settings */}
                        {//!isNull(auth) && auth?.isLoged() && userRole === roles?.master ?
                            !isUndNullEmp({ data: auth, subMethod: currentMethod, })?.result && auth?.isLoged() &&
                                !isUndNullEmp({ data: userRole, subMethod: currentMethod, })?.result ?
                                <li className={viewName === viewNames?.settings && !isUndNullEmp({ data: process, subMethod: currentMethod })?.result ? navSetting?.navItemMenuOpen : navSetting?.navItem}>
                                    <a href='#nothing' className={viewName === viewNames?.settings && !isUndNullEmp({ data: process, subMethod: currentMethod })?.result ? navSetting?.navLinkActive : navSetting?.navLink}>
                                        <i className='nav-icon fas fa-cogs' />
                                        <p>{labels?.settings?.[languageObj?.id]}<i className={icons?.angleLeftRight} /></p>
                                    </a>
                                    <ul className='nav nav-treeview'>
                                        <li className='nav-item'>
                                            <a href={backend?.urlCountries} className={process === processes?.countries ? navSetting?.navLinkActive : navSetting?.navLink}>
                                                <i className={icons?.circleNavIcon} />
                                                <p>{labels?.countries?.[languageObj?.id]}</p>
                                            </a>
                                        </li>
                                        <li className='nav-item'>
                                            <a href={backend?.urlCoins} className={process === processes?.coins ? navSetting?.navLinkActive : navSetting?.navLink}>
                                                <i className={icons?.circleNavIcon} />
                                                <p>{labels?.coins?.[languageObj?.id]}</p>
                                            </a>
                                        </li>
                                        <li className='nav-item'>
                                            <a href={backend?.urlBanks} className={process === processes?.banks ? navSetting?.navLinkActive : navSetting?.navLink}>
                                                <i className={icons?.circleNavIcon} />
                                                <p>{labels?.banks?.[languageObj?.id]}</p>
                                            </a>
                                        </li>
                                        <li className='nav-item'>
                                            <a href={backend?.urlPaymentMethods} className={process === processes?.paymentMethods ? navSetting?.navLinkActive : navSetting?.navLink}>
                                                <i className={icons?.circleNavIcon} />
                                                <p>{labels?.paymentMethods?.[languageObj?.id]}</p>
                                            </a>
                                        </li>
                                        <li className='nav-item'>
                                            <a href={backend?.urlTaxes} className={process === processes?.taxes ? navSetting?.navLinkActive : navSetting?.navLink}>
                                                <i className={icons?.circleNavIcon} />
                                                <p>{labels?.taxes?.[languageObj?.id]}</p>
                                            </a>
                                        </li>
                                        {!isUndNullEmp({ data: auth, subMethod: currentMethod, })?.result && auth?.isLoged() &&
                                            !isUndNullEmp({ data: userRole, subMethod: currentMethod, })?.result &&
                                            (userRole === roles?.master || userRole === roles?.admin) ?
                                            <li className='nav-item'>
                                                <a href={backend?.urlPeopleTypes} className={process === processes?.peopleTypes ? navSetting?.navLinkActive : navSetting?.navLink}>
                                                    <i className={icons?.circleNavIcon} />
                                                    <p>{labels?.peopleTypes?.[languageObj?.id]}</p>
                                                </a>
                                            </li> :
                                            <></>
                                        }
                                        {/* <li className='nav-item'>
                                        <a href='/documents' className={process === 'documents' ? navSetting?.navLinkActive : navSetting?.navLink}>
                                            <i className={icons?.circleNavIcon} />
                                            <p>{labels?.document?.[languageObj?.id]}</p>
                                        </a>
                                    </li> */}
                                        {!isUndNullEmp({ data: auth, subMethod: currentMethod, })?.result && auth?.isLoged() &&
                                            !isUndNullEmp({ data: userRole, subMethod: currentMethod, })?.result &&
                                            (userRole === roles?.master || userRole === roles?.admin) ?
                                            <li className='nav-item'>
                                                <a href={backend?.urlRoles} className={process === processes?.roles ? navSetting?.navLinkActive : navSetting?.navLink}>
                                                    <i className={icons?.circleNavIcon} />
                                                    <p>{labels?.roles?.[languageObj?.id]}</p>
                                                </a>
                                            </li> :
                                            <></>
                                        }
                                        {!isUndNullEmp({ data: auth, subMethod: currentMethod, })?.result && auth?.isLoged() &&
                                            !isUndNullEmp({ data: userRole, subMethod: currentMethod, })?.result &&
                                            (userRole === roles?.master || userRole === roles?.admin) ?
                                            <li className='nav-item'>
                                                <a href={backend?.urlUsers} className={process === processes?.users ? navSetting?.navLinkActive : navSetting?.navLink}>
                                                    <i className={icons?.circleNavIcon} />
                                                    <p>{labels?.users?.[languageObj?.id]}</p>
                                                </a>
                                            </li> :
                                            <></>
                                        }
                                    </ul>
                                </li>
                                : <div></div>
                        }

                        {/* {!isNull(auth) && auth?.isLoged() && userRole === roles?.admin ?
                            <li className='nav-item'>
                                <a href='#nothing' className='nav-link'>
                                    <i className='nav-icon fas fa-tree' />
                                    <p>UI Elements <i className={icons?.angleLeftRight} /></p>
                                </a>
                                <ul className='nav nav-treeview'>
                                    <li className='nav-item'>
                                    <a href='pages/UI/general.html' className='nav-link'>
                                        <i className={icons?.circleNavIcon} />
                                        <p>General</p>
                                    </a>
                                    </li>
                                    <li className='nav-item'>
                                        <a href='pages/UI/icons.html' className='nav-link'>
                                            <i className={icons?.circleNavIcon} />
                                            <p>Icons</p>
                                        </a>
                                    </li>
                                    <li className='nav-item'>
                                        <a href='pages/UI/buttons.html' className='nav-link'>
                                            <i className={icons?.circleNavIcon} />
                                            <p>Buttons</p>
                                        </a>
                                    </li>
                                    <li className='nav-item'>
                                        <a href='pages/UI/sliders.html' className='nav-link'>
                                            <i className={icons?.circleNavIcon} />
                                            <p>Sliders</p>
                                        </a>
                                    </li>
                                </ul>
                            </li>
                            : <div></div>
                        } */}

                        <hr className='text-secondary' />
                        <li className='nav-header text-warning'>{labels?.sessionUpCase?.[languageObj?.id]}</li>

                        <li className='nav-item'>
                            {
                                auth?.isLoged() ?
                                    <Link to={auth?.isLoged() ? '/logOff' : backend?.urlLogin} onClick={auth?.isLoged() ? (e) => signOutShowModelAsync({ e: e, }) : null} className='nav-link'>
                                        <i className={auth?.isLoged() ? 'fas fa-sign-out-alt nav-icon' : 'fas fa-sign-in-alt nav-icon'} /> <p>{auth?.isLoged() ? labels?.logOff?.[languageObj?.id] : labels?.login?.[languageObj?.id]}</p>
                                    </Link> :

                                    <a className='nav-link' href={backend?.urlLogin}>
                                        <i className='fas fa-sign-in-alt nav-icon' /> <p>{labels?.login?.[languageObj?.id]}</p>
                                    </a>
                                // <Link to=backend?.urlLogin className='nav-link'>
                                //     <i className='fas fa-sign-in-alt nav-icon' /> <p>{labels?.login?.[languageObj?.id]}</p>
                                // </Link>
                            }
                        </li>

                        {/* <li className='nav-item'>
                        <a href='#nothing' className='nav-link'>
                            <i className='nav-icon fas fa-copy' />
                            <p>
                            Layout Options
                            <i className='fas fa-angle-left right' />
                            <span className='badge badge-info right'>6</span>
                            </p>
                        </a>
                        <ul className='nav nav-treeview'>
                            <li className='nav-item'>
                            <a href='pages/layout/top-nav.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>Top Navigation</p>
                            </a>
                            </li>
                            <li className='nav-item'>
                            <a href='pages/layout/top-nav-sidebar.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>Top Navigation + Sidebar</p>
                            </a>
                            </li>
                            <li className='nav-item'>
                            <a href='pages/layout/boxed.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>Boxed</p>
                            </a>
                            </li>
                            <li className='nav-item'>
                            <a href='pages/layout/fixed-sidebar.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>Fixed Sidebar</p>
                            </a>
                            </li>
                            <li className='nav-item'>
                            <a href='pages/layout/fixed-sidebar-custom.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>Fixed Sidebar <small>+ Custom Area</small></p>
                            </a>
                            </li>
                            <li className='nav-item'>
                            <a href='pages/layout/fixed-topnav.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>Fixed Navbar</p>
                            </a>
                            </li>
                            <li className='nav-item'>
                            <a href='pages/layout/fixed-footer.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>Fixed Footer</p>
                            </a>
                            </li>
                            <li className='nav-item'>
                            <a href='pages/layout/collapsed-sidebar.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>Collapsed Sidebar</p>
                            </a>
                            </li>
                        </ul>
                        </li>
                        <li className='nav-item'>
                        <a href='#nothing' className='nav-link'>
                            <i className='nav-icon fas fa-chart-pie' />
                            <p>
                            Charts
                            <i className={icons?.angleLeftRight} />
                            </p>
                        </a>
                        <ul className='nav nav-treeview'>
                            <li className='nav-item'>
                            <a href='pages/charts/chartjs.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>ChartJS</p>
                            </a>
                            </li>
                            <li className='nav-item'>
                            <a href='pages/charts/flot.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>Flot</p>
                            </a>
                            </li>
                            <li className='nav-item'>
                            <a href='pages/charts/inline.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>Inline</p>
                            </a>
                            </li>
                            <li className='nav-item'>
                            <a href='pages/charts/uplot.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>uPlot</p>
                            </a>
                            </li>
                        </ul>
                        </li>
                        <li className='nav-item'>
                        <a href='#nothing' className='nav-link'>
                            <i className='nav-icon fas fa-tree' />
                            <p>
                            UI Elements
                            <i className='fas fa-angle-left right' />
                            </p>
                        </a>
                        <ul className='nav nav-treeview'>
                            <li className='nav-item'>
                            <a href='pages/UI/general.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>General</p>
                            </a>
                            </li>
                            <li className='nav-item'>
                            <a href='pages/UI/icons.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>Icons</p>
                            </a>
                            </li>
                            <li className='nav-item'>
                            <a href='pages/UI/buttons.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>Buttons</p>
                            </a>
                            </li>
                            <li className='nav-item'>
                            <a href='pages/UI/sliders.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>Sliders</p>
                            </a>
                            </li>
                            <li className='nav-item'>
                            <a href='pages/UI/modals.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>Modals &amp; Alerts</p>
                            </a>
                            </li>
                            <li className='nav-item'>
                            <a href='pages/UI/navbar.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>Navbar &amp; Tabs</p>
                            </a>
                            </li>
                            <li className='nav-item'>
                            <a href='pages/UI/timeline.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>Timeline</p>
                            </a>
                            </li>
                            <li className='nav-item'>
                            <a href='pages/UI/ribbons.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>Ribbons</p>
                            </a>
                            </li>
                        </ul>
                        </li>
                        <li className='nav-item'>
                        <a href='#nothing' className='nav-link'>
                            <i className='nav-icon fas fa-edit' />
                            <p>
                            Forms
                            <i className='fas fa-angle-left right' />
                            </p>
                        </a>
                        <ul className='nav nav-treeview'>
                            <li className='nav-item'>
                            <a href='pages/forms/general.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>General Elements</p>
                            </a>
                            </li>
                            <li className='nav-item'>
                            <a href='pages/forms/advanced.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>Advanced Elements</p>
                            </a>
                            </li>
                            <li className='nav-item'>
                            <a href='pages/forms/editors.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>Editors</p>
                            </a>
                            </li>
                            <li className='nav-item'>
                            <a href='pages/forms/validation.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>Validation</p>
                            </a>
                            </li>
                        </ul>
                        </li>
                        <li className='nav-item'>
                        <a href='#nothing' className='nav-link'>
                            <i className='nav-icon fas fa-table' />
                            <p>
                            Tables
                            <i className='fas fa-angle-left right' />
                            </p>
                        </a>
                        <ul className='nav nav-treeview'>
                            <li className='nav-item'>
                            <a href='pages/tables/simple.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>Simple Tables</p>
                            </a>
                            </li>
                            <li className='nav-item'>
                            <a href='pages/tables/data.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>DataTables</p>
                            </a>
                            </li>
                            <li className='nav-item'>
                            <a href='pages/tables/jsgrid.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>jsGrid</p>
                            </a>
                            </li>
                        </ul>
                        </li>
                        <li className='nav-header'>EXAMPLES</li>
                        <li className='nav-item'>
                        <a href='pages/calendar.html' className='nav-link'>
                            <i className='nav-icon far fa-calendar-alt' />
                            <p>
                            Calendar
                            <span className='badge badge-info right'>2</span>
                            </p>
                        </a>
                        </li>
                        <li className='nav-item'>
                        <a href='pages/gallery.html' className='nav-link'>
                            <i className='nav-icon far fa-image' />
                            <p>
                            Gallery
                            </p>
                        </a>
                        </li>
                        <li className='nav-item'>
                        <a href='pages/kanban.html' className='nav-link'>
                            <i className='nav-icon fas fa-columns' />
                            <p>
                            Kanban Board
                            </p>
                        </a>
                        </li>
                        <li className='nav-item'>
                        <a href='#nothing' className='nav-link'>
                            <i className='nav-icon far fa-envelope' />
                            <p>
                            Mailbox
                            <i className='fas fa-angle-left right' />
                            </p>
                        </a>
                        <ul className='nav nav-treeview'>
                            <li className='nav-item'>
                            <a href='pages/mailbox/mailbox.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>Inbox</p>
                            </a>
                            </li>
                            <li className='nav-item'>
                            <a href='pages/mailbox/compose.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>Compose</p>
                            </a>
                            </li>
                            <li className='nav-item'>
                            <a href='pages/mailbox/read-mail.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>Read</p>
                            </a>
                            </li>
                        </ul>
                        </li>
                        <li className='nav-item'>
                        <a href='#nothing' className='nav-link'>
                            <i className='nav-icon fas fa-book' />
                            <p>
                            Pages
                            <i className='fas fa-angle-left right' />
                            </p>
                        </a>
                        <ul className='nav nav-treeview'>
                            <li className='nav-item'>
                            <a href='pages/examples/invoice.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>Invoice</p>
                            </a>
                            </li>
                            <li className='nav-item'>
                            <a href='pages/examples/profile.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>Profile</p>
                            </a>
                            </li>
                            <li className='nav-item'>
                            <a href='pages/examples/e-commerce.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>E-commerce</p>
                            </a>
                            </li>
                            <li className='nav-item'>
                            <a href='pages/examples/projects.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>Projects</p>
                            </a>
                            </li>
                            <li className='nav-item'>
                            <a href='pages/examples/project-add.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>Project Add</p>
                            </a>
                            </li>
                            <li className='nav-item'>
                            <a href='pages/examples/project-edit.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>Project Edit</p>
                            </a>
                            </li>
                            <li className='nav-item'>
                            <a href='pages/examples/project-detail.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>Project Detail</p>
                            </a>
                            </li>
                            <li className='nav-item'>
                            <a href='pages/examples/contacts.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>Contacts</p>
                            </a>
                            </li>
                            <li className='nav-item'>
                            <a href='pages/examples/faq.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>FAQ</p>
                            </a>
                            </li>
                            <li className='nav-item'>
                            <a href='pages/examples/contact-us.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>Contact us</p>
                            </a>
                            </li>
                        </ul>
                        </li>
                        <li className='nav-item'>
                        <a href='#nothing' className='nav-link'>
                            <i className='nav-icon far fa-plus-square' />
                            <p>
                            Extras
                            <i className='fas fa-angle-left right' />
                            </p>
                        </a>
                        <ul className='nav nav-treeview'>
                            <li className='nav-item'>
                            <a href='#nothing' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>
                                Login &amp; Register v1
                                <i className='fas fa-angle-left right' />
                                </p>
                            </a>
                            <ul className='nav nav-treeview'>
                                <li className='nav-item'>
                                <a href='pages/examples/login.html' className='nav-link'>
                                    <i className={icons?.circleNavIcon} />
                                    <p>Login v1</p>
                                </a>
                                </li>
                                <li className='nav-item'>
                                <a href='pages/examples/register.html' className='nav-link'>
                                    <i className={icons?.circleNavIcon} />
                                    <p>Register v1</p>
                                </a>
                                </li>
                                <li className='nav-item'>
                                <a href='pages/examples/forgot-password.html' className='nav-link'>
                                    <i className={icons?.circleNavIcon} />
                                    <p>Forgot Password v1</p>
                                </a>
                                </li>
                                <li className='nav-item'>
                                <a href='pages/examples/recover-password.html' className='nav-link'>
                                    <i className={icons?.circleNavIcon} />
                                    <p>Recover Password v1</p>
                                </a>
                                </li>
                            </ul>
                            </li>
                            <li className='nav-item'>
                            <a href='#nothing' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>
                                Login &amp; Register v2
                                <i className='fas fa-angle-left right' />
                                </p>
                            </a>
                            <ul className='nav nav-treeview'>
                                <li className='nav-item'>
                                <a href='pages/examples/login-v2.html' className='nav-link'>
                                    <i className={icons?.circleNavIcon} />
                                    <p>Login v2</p>
                                </a>
                                </li>
                                <li className='nav-item'>
                                <a href='pages/examples/register-v2.html' className='nav-link'>
                                    <i className={icons?.circleNavIcon} />
                                    <p>Register v2</p>
                                </a>
                                </li>
                                <li className='nav-item'>
                                <a href='pages/examples/forgot-password-v2.html' className='nav-link'>
                                    <i className={icons?.circleNavIcon} />
                                    <p>Forgot Password v2</p>
                                </a>
                                </li>
                                <li className='nav-item'>
                                <a href='pages/examples/recover-password-v2.html' className='nav-link'>
                                    <i className={icons?.circleNavIcon} />
                                    <p>Recover Password v2</p>
                                </a>
                                </li>
                            </ul>
                            </li>
                            <li className='nav-item'>
                            <a href='pages/examples/lockscreen.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>Lockscreen</p>
                            </a>
                            </li>
                            <li className='nav-item'>
                            <a href='pages/examples/legacy-user-menu.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>Legacy User Menu</p>
                            </a>
                            </li>
                            <li className='nav-item'>
                            <a href='pages/examples/language-menu.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>Language Menu</p>
                            </a>
                            </li>
                            <li className='nav-item'>
                            <a href='pages/examples/404.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>Error 404</p>
                            </a>
                            </li>
                            <li className='nav-item'>
                            <a href='pages/examples/500.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>Error 500</p>
                            </a>
                            </li>
                            <li className='nav-item'>
                            <a href='pages/examples/pace.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>Pace</p>
                            </a>
                            </li>
                            <li className='nav-item'>
                            <a href='pages/examples/blank.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>Blank Page</p>
                            </a>
                            </li>
                            <li className='nav-item'>
                            <a href='starter.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>Starter Page</p>
                            </a>
                            </li>
                        </ul>
                        </li>
                        <li className='nav-item'>
                        <a href='#nothing' className='nav-link'>
                            <i className='nav-icon fas fa-search' />
                            <p>
                            Search
                            <i className='fas fa-angle-left right' />
                            </p>
                        </a>
                        <ul className='nav nav-treeview'>
                            <li className='nav-item'>
                            <a href='pages/search/simple.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>Simple Search</p>
                            </a>
                            </li>
                            <li className='nav-item'>
                            <a href='pages/search/enhanced.html' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>Enhanced</p>
                            </a>
                            </li>
                        </ul>
                        </li>
                        <li className='nav-header'>MISCELLANEOUS</li>
                        <li className='nav-item'>
                        <a href='iframe.html' className='nav-link'>
                            <i className='nav-icon fas fa-ellipsis-h' />
                            <p>Tabbed IFrame Plugin</p>
                        </a>
                        </li>
                        <li className='nav-item'>
                        <a href='https://adminlte.io/docs/3.1/' className='nav-link'>
                            <i className='nav-icon fas fa-file' />
                            <p>Documentation</p>
                        </a>
                        </li>
                        <li className='nav-header'>MULTI LEVEL EXAMPLE</li>
                        <li className='nav-item'>
                        <a href='#nothing' className='nav-link'>
                            <i className='fas fa-circle nav-icon' />
                            <p>Level 1</p>
                        </a>
                        </li>
                        <li className='nav-item'>
                        <a href='#nothing' className='nav-link'>
                            <i className='nav-icon fas fa-circle' />
                            <p>
                            Level 1
                            <i className={icons?.angleLeftRight} />
                            </p>
                        </a>
                        <ul className='nav nav-treeview'>
                            <li className='nav-item'>
                            <a href='#nothing' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>Level 2</p>
                            </a>
                            </li>
                            <li className='nav-item'>
                            <a href='#nothing' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>
                                Level 2
                                <i className={icons?.angleLeftRight} />
                                </p>
                            </a>
                            <ul className='nav nav-treeview'>
                                <li className='nav-item'>
                                <a href='#nothing' className='nav-link'>
                                    <i className='far fa-dot-circle nav-icon' />
                                    <p>Level 3</p>
                                </a>
                                </li>
                                <li className='nav-item'>
                                <a href='#nothing' className='nav-link'>
                                    <i className='far fa-dot-circle nav-icon' />
                                    <p>Level 3</p>
                                </a>
                                </li>
                                <li className='nav-item'>
                                <a href='#nothing' className='nav-link'>
                                    <i className='far fa-dot-circle nav-icon' />
                                    <p>Level 3</p>
                                </a>
                                </li>
                            </ul>
                            </li>
                            <li className='nav-item'>
                            <a href='#nothing' className='nav-link'>
                                <i className={icons?.circleNavIcon} />
                                <p>Level 2</p>
                            </a>
                            </li>
                        </ul>
                        </li>
                        <li className='nav-item'>
                        <a href='#nothing' className='nav-link'>
                            <i className='fas fa-circle nav-icon' />
                            <p>Level 1</p>
                        </a>
                        </li>
                        <li className='nav-header'>LABELS</li>
                        <li className='nav-item'>
                        <a href='#nothing' className='nav-link'>
                            <i className='nav-icon far fa-circle text-danger' />
                            <p className='text'>Important</p>
                        </a>
                        </li>
                        <li className='nav-item'>
                        <a href='#nothing' className='nav-link'>
                            <i className='nav-icon far fa-circle text-warning' />
                            <p>Warning</p>
                        </a>
                        </li>
                        <li className='nav-item'>
                        <a href='#nothing' className='nav-link'>
                            <i className='nav-icon far fa-circle text-info' />
                            <p>Informational</p>
                        </a>
                        </li> */}
                    </ul>
                </nav>
                {/* /.sidebar-menu */}
            </div>
            {/* /.sidebar */}
        </aside>
    )
}